import { GET_LAB_TEST_SLOT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Request {
    vendor: string;
    date: string;
    address: AddressObj;
    vendor_id: string;
}

export interface AddressObj {
    city: string;
    line: string;
    state: string;
    city_id: string;
    pincode: string;
    landmark: string;
    coordinates: string;
}

interface Response {
    success: boolean;
    data: Slot[];
    error?: string;
}

export interface Slot {
    id: number;
    quantity: number;
    details: Details;
}

export interface Details {
    start_time: string;
    end_time: string;
}

export default (docid: string, request: Request): Promise<Response> => {
    return fetchWithRefresh(GET_LAB_TEST_SLOT(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
